import Axios from "axios";
// import { apiKey } from "../../apiKeys";
// import { baseURL } from "../../apiKeys";

export const baseUrlNoAuth = Axios.create({
  baseURL: "https://cvgcoops.com.ng/api/v1/",
  // baseURL: "http://staging.cvgcoops.com.ng/api/v1/",
  headers: { "Content-Type": "application/json" },
});

export const baseUrlWithAuth = Axios.create({
  baseURL: "https://cvgcoops.com.ng/api/v1/",
  // baseURL: "http://staging.cvgcoops.com.ng/api/v1/",
  headers: {
    "Content-Type": "application/json",
  },
});

export const virtualAccountBaseUrl = Axios.create({
  baseURL: "https://zippyworld.net/zippy_event_third_party/v1/api",
  headers: {
    "x-api-key": "6128892",
    "Content-Type": "application/json",
  },
});

baseUrlWithAuth.interceptors.request.use(
  (config) => {
    const accessKey = JSON.parse(
      localStorage.getItem("userSessionData"),
    )?.access;
    if (accessKey) {
      config.headers["Authorization"] = `Bearer ${accessKey}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);
